const getEnvironment = () => {
  if (typeof window !== 'undefined' && window.location.href.includes('myfert-dev.netlify.app/')) {
    return 'development';
  }
  return process.env.NODE_ENV || 'development';
};

const env = getEnvironment(); 

export const baseUrl = env === 'production' 
  ? 'https://dev.backend.myfertilitylabs.com/api/'
  : 'https://dev.backend.myfertilitylabs.com/api/';

export const getBaseUrl = () => baseUrl;

export const notificationURL = process.env.REACT_APP_API_Notification_URL;
export const Key = process.env.REACT_APP_API_MAP_KEY;
